import {
  ApiRoute,
  CreateUserProfile,
  ProfileDetail,
  ProfileDetailSchema,
  UpdateUserProfile,
  User,
  UserSchema,
  getApiRoute
} from "@garther/interfaces";

import { API_BASE_URL } from "../configs";
import { ApiError, BaseApiClient } from "./base-client";

export class ProfileApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.PROFILE),
      requireAuth: true
    });
  }

  async getMyProfile(): Promise<ProfileDetail | null> {
    try {
      return await this.get("me", ProfileDetailSchema, { requireAuth: true });
    } catch (error) {
      // Return null for 404 errors (profile not found)
      if ((error as ApiError).status === 404) {
        return null;
      }
      throw error;
    }
  }

  async getProfileByUserId(userId: string): Promise<ProfileDetail | null> {
    try {
      return await this.get(userId, ProfileDetailSchema, { requireAuth: false });
    } catch (error) {
      // Return null for 404 errors (profile not found)
      if ((error as ApiError).status === 404) {
        return null;
      }
      throw error;
    }
  }

  // Convenience methods for current user (recommended)
  async createMyProfile(profileData: CreateUserProfile): Promise<User> {
    try {
      return await this.post("me", UserSchema, profileData, { requireAuth: true });
    } catch (error) {
      throw new Error((error as ApiError).message || "Failed to create profile");
    }
  }

  async updateMyProfile(updateData: UpdateUserProfile): Promise<ProfileDetail> {
    try {
      return await this.put("me", ProfileDetailSchema, updateData, { requireAuth: true });
    } catch (error) {
      throw new Error((error as ApiError).message || "Failed to update profile");
    }
  }

  // async deleteMyProfile(): Promise<void> {
  //   const response = await this.delete<ApiResp<void>>("me", { requireAuth: true });

  //   if (!response.success) {
  //     throw new Error(response.error || "Failed to delete profile");
  //   }
  // }

  async uploadAvatar(file: File): Promise<ProfileDetail> {
    try {
      const formData = new FormData();
      formData.append("avatar", file);

      return await this.post("me/avatar", ProfileDetailSchema, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    } catch (error) {
      throw new Error((error as ApiError).message || "Failed to upload avatar");
    }
  }
}

// Create and export the profile API client instance
export const profileApiClient = new ProfileApiClient();
